function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1693 51.4247C12.4267 48.0059 14.5591 40.9796 21.0301 40.2252C29.119 39.2822 31.1995 51.5017 18.1878 46.7876C5.17604 42.0735 37.6647 56.3232 40.8365 44.1472",
  stroke: "#00D88A",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0362 11H8.80724C7.00185 11 5.2704 11.7164 3.99379 12.9916C2.71719 14.2669 2 15.9964 2 17.7999V72.199C2 74.0024 2.71719 75.732 3.99379 77.0072C5.2704 78.2824 7.00185 78.9989 8.80724 78.9989H49.6507C51.4561 78.9989 53.1875 78.2824 54.4641 77.0072C55.7407 75.732 56.4579 74.0024 56.4579 72.199V31.3997",
  stroke: "#00D88A",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8055 59.5396H15.4013",
  stroke: "#99EFD0",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59.757 11.467C59.6092 11.318 59.4333 11.1996 59.2395 11.1189C59.0457 11.0382 58.8378 10.9966 58.6278 10.9966C58.4179 10.9966 58.21 11.0382 58.0162 11.1189C57.8224 11.1996 57.6465 11.318 57.4986 11.467L45.65 23.3315L40.672 18.3376C40.5185 18.1893 40.3373 18.0727 40.1387 17.9945C39.9402 17.9162 39.7281 17.8778 39.5147 17.8815C39.3013 17.8852 39.0907 17.9309 38.895 18.016C38.6992 18.1011 38.5222 18.2239 38.3739 18.3774C38.2256 18.5309 38.109 18.7121 38.0307 18.9107C37.9525 19.1093 37.9141 19.3213 37.9178 19.5347C37.9215 19.7481 37.9672 19.9587 38.0522 20.1544C38.1373 20.3502 38.2601 20.5272 38.4136 20.6755L44.5208 26.7827C44.6687 26.9318 44.8446 27.0501 45.0384 27.1309C45.2322 27.2116 45.4401 27.2532 45.65 27.2532C45.86 27.2532 46.0679 27.2116 46.2617 27.1309C46.4555 27.0501 46.6314 26.9318 46.7792 26.7827L59.757 13.8049C59.9185 13.656 60.0473 13.4753 60.1354 13.2741C60.2235 13.0729 60.269 12.8556 60.269 12.636C60.269 12.4163 60.2235 12.1991 60.1354 11.9979C60.0473 11.7967 59.9185 11.616 59.757 11.467Z",
  fill: "#00D88A"
});

function SvgContratoAssinadoIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 81,
    viewBox: "0 0 69 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContratoAssinadoIcon);
export default __webpack_public_path__ + "static/media/contrato-assinado-icon.2c5574492421bd7a853ad2d1383516d9.svg";
export { ForwardRef as ReactComponent };